import { render, staticRenderFns } from "./e-button-main.vue?vue&type=template&id=ffa5b1e0&scoped=true&lang=pug&"
import script from "./e-button-main.vue?vue&type=script&lang=js&"
export * from "./e-button-main.vue?vue&type=script&lang=js&"
import style0 from "./e-button-main.vue?vue&type=style&index=0&id=ffa5b1e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa5b1e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
